import { z } from 'zod';
import { CHAT_MAX_LENGTH, CHAT_PAGE_SIZE, CHAT_PAGE_SIZE_MAX } from '../constants.js';
export const chatSendSchema = z.object({
    scope: z.enum(['global', 'proximity']),
    body: z.string().trim().min(1).max(CHAT_MAX_LENGTH),
});
export const chatHistorySchema = z.object({
    beforeId: z.number().int().positive().optional(),
    limit: z.number().int().min(1).max(CHAT_PAGE_SIZE_MAX).default(CHAT_PAGE_SIZE),
});
//# sourceMappingURL=chatSchema.js.map